import { render, staticRenderFns } from "./LeakageCauseEquipmentQuestion.vue?vue&type=template&id=28cc59a4"
import script from "./LeakageCauseEquipmentQuestion.vue?vue&type=script&lang=ts"
export * from "./LeakageCauseEquipmentQuestion.vue?vue&type=script&lang=ts"
import style0 from "./LeakageCauseEquipmentQuestion.vue?vue&type=style&index=0&id=28cc59a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports